var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "title" }, [_vm._v("Filtros")]),
    !_vm.isFiltroProcesso
      ? _c(
          "div",
          [
            _c(
              "el-row",
              { staticClass: "labelDiv", attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  {
                    staticClass: "inputDiv container-input mb",
                    attrs: { span: 8 }
                  },
                  [
                    _c("app-label", {
                      attrs: { label: "Ordem de serviço", required: false }
                    }),
                    _c(
                      "el-select",
                      {
                        staticClass: "input select",
                        attrs: {
                          multiple: "multiple",
                          "collapse-tags": "collapse-tags",
                          filterable: "filterable",
                          placeholder: "Selecione",
                          "value-key": "id"
                        },
                        model: {
                          value: _vm.filtroOs.ordensServico,
                          callback: function($$v) {
                            _vm.$set(_vm.filtroOs, "ordensServico", $$v)
                          },
                          expression: "filtroOs.ordensServico"
                        }
                      },
                      _vm._l(_vm.osList, function(os) {
                        return _c("el-option", {
                          key: os.id,
                          staticClass: "selectOs",
                          attrs: { label: os.numero, value: os.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  {
                    staticClass: "inputDiv container-input mb",
                    attrs: { span: 8 }
                  },
                  [
                    _c("app-label", {
                      attrs: { label: "Técnico de campo", required: false }
                    }),
                    _c(
                      "el-select",
                      {
                        staticClass: "input select",
                        attrs: {
                          multiple: "multiple",
                          "collapse-tags": "collapse-tags",
                          filterable: "filterable",
                          placeholder: "Selecione",
                          "value-key": "id"
                        },
                        model: {
                          value: _vm.filtroOs.tecnicosCampo,
                          callback: function($$v) {
                            _vm.$set(_vm.filtroOs, "tecnicosCampo", $$v)
                          },
                          expression: "filtroOs.tecnicosCampo"
                        }
                      },
                      _vm._l(_vm.tecnicoDeCampoList, function(tecnicoDeCampo) {
                        return _c("el-option", {
                          key: tecnicoDeCampo.id,
                          staticClass: "selectText",
                          attrs: {
                            label: tecnicoDeCampo.pessoa.pessoaFisica.nome,
                            value: tecnicoDeCampo.id
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  {
                    staticClass: "inputDiv container-input mb",
                    attrs: { span: 8 }
                  },
                  [
                    _c("app-label", {
                      attrs: {
                        label: "Período referente à criação da OS",
                        required: false
                      }
                    }),
                    _c("el-date-picker", {
                      attrs: {
                        type: "daterange",
                        "unlink-panels": "unlink-panels",
                        "range-separator": "até",
                        "start-placeholder": "Início",
                        "end-placeholder": "Fim",
                        format: "dd/MM/yyyy",
                        "picker-options": _vm.pickerOptions
                      },
                      model: {
                        value: _vm.filtroOs.periodoInsercao,
                        callback: function($$v) {
                          _vm.$set(_vm.filtroOs, "periodoInsercao", $$v)
                        },
                        expression: "filtroOs.periodoInsercao"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-row",
              { staticClass: "labelDiv", attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  {
                    staticClass: "inputDiv container-input",
                    attrs: { span: 8 }
                  },
                  [
                    _c("app-label", {
                      attrs: { label: "Tipo de processo", required: false }
                    }),
                    _c(
                      "el-select",
                      {
                        staticClass: "input select",
                        attrs: {
                          multiple: "multiple",
                          "collapse-tags": "collapse-tags",
                          filterable: "filterable",
                          placeholder: "Selecione",
                          "value-key": "id"
                        },
                        model: {
                          value: _vm.filtroOs.tiposProcesso,
                          callback: function($$v) {
                            _vm.$set(_vm.filtroOs, "tiposProcesso", $$v)
                          },
                          expression: "filtroOs.tiposProcesso"
                        }
                      },
                      _vm._l(_vm.tipoProcessoList, function(tipoProcesso) {
                        return _c("el-option", {
                          key: tipoProcesso.codigo,
                          attrs: {
                            label: tipoProcesso.nome,
                            value: tipoProcesso.codigo
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  {
                    staticClass: "inputDiv container-input",
                    attrs: { span: 8 }
                  },
                  [
                    _c("app-label", {
                      attrs: { label: "Município", required: false }
                    }),
                    _c(
                      "el-select",
                      {
                        staticClass: "input select",
                        attrs: {
                          multiple: "multiple",
                          "collapse-tags": "collapse-tags",
                          filterable: "filterable",
                          placeholder: "Selecione",
                          "value-key": "id"
                        },
                        model: {
                          value: _vm.filtroOs.municipios,
                          callback: function($$v) {
                            _vm.$set(_vm.filtroOs, "municipios", $$v)
                          },
                          expression: "filtroOs.municipios"
                        }
                      },
                      _vm._l(_vm.municipioList, function(municipio) {
                        return _c("el-option", {
                          key: municipio.id,
                          attrs: { label: municipio.label, value: municipio.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c("el-col", {
                  staticClass: "container-input",
                  attrs: { span: 8 }
                })
              ],
              1
            )
          ],
          1
        )
      : _c(
          "div",
          [
            _c(
              "el-row",
              { staticClass: "labelDiv", attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  {
                    staticClass: "inputDiv container-input mb",
                    attrs: { span: 8 }
                  },
                  [
                    _c("app-label", {
                      attrs: { label: "Número do processo", required: false }
                    }),
                    _c("el-input", {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: ["#########/####"],
                          expression: "['#########/####']"
                        }
                      ],
                      staticClass: "input select",
                      model: {
                        value: _vm.filtroProcesso.numeroProcesso,
                        callback: function($$v) {
                          _vm.$set(_vm.filtroProcesso, "numeroProcesso", $$v)
                        },
                        expression: "filtroProcesso.numeroProcesso"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-col",
                  {
                    staticClass: "inputDiv container-input mb",
                    attrs: { span: 8 }
                  },
                  [
                    _c("app-label", {
                      attrs: { label: "Ordem de serviço", required: false }
                    }),
                    _c(
                      "el-select",
                      {
                        staticClass: "input select",
                        attrs: {
                          "collapse-tags": "collapse-tags",
                          multiple: "multiple",
                          filterable: "filterable",
                          placeholder: "Selecione",
                          "value-key": "id"
                        },
                        model: {
                          value: _vm.filtroProcesso.listIdOrdemServico,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.filtroProcesso,
                              "listIdOrdemServico",
                              $$v
                            )
                          },
                          expression: "filtroProcesso.listIdOrdemServico"
                        }
                      },
                      _vm._l(_vm.osList, function(os) {
                        return _c("el-option", {
                          key: os.id,
                          staticClass: "selectOs",
                          attrs: { label: os.numero, value: os.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  {
                    staticClass: "inputDiv container-input mb",
                    attrs: { span: 8 }
                  },
                  [
                    _c("app-label", {
                      attrs: { label: "Município", required: false }
                    }),
                    _c(
                      "el-select",
                      {
                        staticClass: "input select",
                        attrs: {
                          "collapse-tags": "collapse-tags",
                          multiple: "multiple",
                          filterable: "filterable",
                          placeholder: "Selecione",
                          "value-key": "id"
                        },
                        model: {
                          value: _vm.filtroProcesso.listIdMunicipio,
                          callback: function($$v) {
                            _vm.$set(_vm.filtroProcesso, "listIdMunicipio", $$v)
                          },
                          expression: "filtroProcesso.listIdMunicipio"
                        }
                      },
                      _vm._l(_vm.municipioList, function(municipio) {
                        return _c("el-option", {
                          key: municipio.id,
                          attrs: { label: municipio.label, value: municipio.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-row",
              { staticClass: "labelDiv", attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  {
                    staticClass: "inputDiv container-input mb",
                    attrs: { span: 8 }
                  },
                  [
                    _c("app-label", {
                      attrs: { label: "Situação", required: false }
                    }),
                    _c(
                      "el-select",
                      {
                        staticClass: "input select",
                        attrs: {
                          "collapse-tags": "collapse-tags",
                          multiple: "multiple",
                          filterable: "filterable",
                          placeholder: "Selecione",
                          "value-key": "id"
                        },
                        model: {
                          value: _vm.filtroProcesso.listCodigoSituacao,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.filtroProcesso,
                              "listCodigoSituacao",
                              $$v
                            )
                          },
                          expression: "filtroProcesso.listCodigoSituacao"
                        }
                      },
                      _vm._l(_vm.situacaoList, function(situacao) {
                        return _c("el-option", {
                          key: situacao.codigo,
                          staticClass: "selectGeral",
                          attrs: {
                            label:
                              situacao.codigo ===
                              "AGUARDANDO_ANALISE_PROCESSO_PAI"
                                ? "Aguardando processo chegar para o Técnico de campo"
                                : situacao.nome,
                            value: situacao.codigo
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  {
                    staticClass: "inputDiv container-input mb",
                    attrs: { span: 8 }
                  },
                  [
                    _c("app-label", {
                      attrs: { label: "Técnico de campo", required: false }
                    }),
                    _c(
                      "el-select",
                      {
                        staticClass: "input select",
                        attrs: {
                          "collapse-tags": "collapse-tags",
                          multiple: "multiple",
                          filterable: "filterable",
                          placeholder: "Selecione",
                          "value-key": "id"
                        },
                        model: {
                          value: _vm.filtroProcesso.listIdTecnicosCampo,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.filtroProcesso,
                              "listIdTecnicosCampo",
                              $$v
                            )
                          },
                          expression: "filtroProcesso.listIdTecnicosCampo"
                        }
                      },
                      _vm._l(_vm.tecnicoDeCampoList, function(tecnicoDeCampo) {
                        return _c("el-option", {
                          key: tecnicoDeCampo.id,
                          staticClass: "selectText",
                          attrs: {
                            label: tecnicoDeCampo.pessoa.pessoaFisica.nome,
                            value: tecnicoDeCampo.id
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  {
                    staticClass: "inputDiv container-input mb",
                    attrs: { span: 8 }
                  },
                  [
                    _c("app-label", {
                      attrs: { label: "Tipo de processo", required: false }
                    }),
                    _c(
                      "el-select",
                      {
                        staticClass: "input select",
                        attrs: {
                          "collapse-tags": "collapse-tags",
                          multiple: "multiple",
                          filterable: "filterable",
                          placeholder: "Selecione",
                          "value-key": "id"
                        },
                        model: {
                          value: _vm.filtroProcesso.listIdTipoCadastro,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.filtroProcesso,
                              "listIdTipoCadastro",
                              $$v
                            )
                          },
                          expression: "filtroProcesso.listIdTipoCadastro"
                        }
                      },
                      _vm._l(_vm.tipoProcessoList, function(tipoProcesso) {
                        return _c("el-option", {
                          key: tipoProcesso.id,
                          attrs: {
                            label: tipoProcesso.nome,
                            value: tipoProcesso.id
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-row",
              { staticClass: "labelDiv", attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  {
                    staticClass: "inputDiv container-input mb",
                    attrs: { span: 8 }
                  },
                  [
                    _c("app-label", {
                      attrs: { label: "Nome do interessado", required: false }
                    }),
                    _c(
                      "el-select",
                      {
                        staticClass: "input select",
                        attrs: {
                          "collapse-tags": "collapse-tags",
                          multiple: "multiple",
                          filterable: "filterable",
                          placeholder: "Selecione",
                          "value-key": "id"
                        },
                        model: {
                          value: _vm.filtroProcesso.listCpfInteressado,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.filtroProcesso,
                              "listCpfInteressado",
                              $$v
                            )
                          },
                          expression: "filtroProcesso.listCpfInteressado"
                        }
                      },
                      _vm._l(_vm.interessadoList, function(interessado) {
                        return _c("el-option", {
                          key: interessado.cpf,
                          staticClass: "selectInteressado",
                          attrs: {
                            label: interessado.nome,
                            value: interessado.cpf
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  {
                    staticClass: "inputDiv container-input mb",
                    attrs: { span: 8 }
                  },
                  [
                    _c("app-label", {
                      attrs: {
                        label: "Período referente à criação da OS",
                        required: false
                      }
                    }),
                    _c("el-date-picker", {
                      attrs: {
                        type: "daterange",
                        "unlink-panels": "unlink-panels",
                        "range-separator": "até",
                        "start-placeholder": "Início",
                        "end-placeholder": "Fim",
                        format: "dd/MM/yyyy",
                        "picker-options": _vm.pickerOptions
                      },
                      model: {
                        value: _vm.filtroProcesso.periodoInsercao,
                        callback: function($$v) {
                          _vm.$set(_vm.filtroProcesso, "periodoInsercao", $$v)
                        },
                        expression: "filtroProcesso.periodoInsercao"
                      }
                    })
                  ],
                  1
                ),
                _c("el-col", {
                  staticClass: "container-input mb",
                  attrs: { span: 8 }
                })
              ],
              1
            )
          ],
          1
        ),
    _c("div", { staticClass: "container-pesquisa" }, [
      _c(
        "div",
        { staticClass: "button-pesquisa" },
        [
          _c(
            "el-button",
            { attrs: { type: "text" }, on: { click: _vm.resetPesquisa } },
            [_vm._v("Limpar")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.pesquisar } },
            [_c("i", { staticClass: "fal fa-search" }), _vm._v("  Pesquisar")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45a9f94c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45a9f94c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios/components/os/Filtro.vue
// module id = null
// module chunks = 